import { theme } from '@branchjs/neo-components';
import AndFilter from '../../../common/support/utils/druid/filters/AndFilter';
import InFilter from '../../../common/support/utils/druid/filters/InFilter';
import { AnalyticsWidgetProps } from './Widgets/AnalyticsWidget';

export const OTT_PAGE_TITLE = 'OTT';

export const OTT_TOP_NAV_TAB_IDS = {
  ANALYTICS: 'mui-tab-ott-analytics',
  PARTNER_MANAGEMENT: 'mui-tab-ott-partner-management',
};

export const OTT_TOP_NAV_TABS = [
  {
    id: OTT_TOP_NAV_TAB_IDS.ANALYTICS,
    route: 'analytics',
    label: 'Analytics',
  },
  {
    id: OTT_TOP_NAV_TAB_IDS.PARTNER_MANAGEMENT,
    route: 'partner-management',
    label: 'Partner Management',
  },
];

export const GROUP_BY_QUERY_TYPE = 'groupby';

export const OTT_ANALYTICS_DEFAULT_FILTER = new AndFilter([
  new InFilter('last_attributed_touch_data_tilde_feature', ['paid advertising']),
]);

export const OTT_ANALYTICS_REQUIRED_FILTER = new InFilter('ott', ['true']);

export const OTT_ANALYTICS_CHART_DEFAULT_FILTER_DIMENSIONS = ['last_attributed_touch_data_tilde_advertising_partner_name'];

export const OTT_ANALYTICS_TABLE_DEFAULT_FILTER_DIMENSIONS = [
  'last_attributed_touch_data_tilde_advertising_partner_name',
  'attributed',
  'cross_device_ott',
];

export const OTT_ANALYTICS_FILTER_DIMENSIONS = [
  'attributed',
  'cross_device_ott',
  'last_attributed_touch_data_tilde_ad_id',
  'last_attributed_touch_data_tilde_ad_name',
  'last_attributed_touch_data_tilde_ad_set_id',
  'last_attributed_touch_data_tilde_ad_set_name',
  'last_attributed_touch_data_tilde_advertising_partner_name',
  'last_attributed_touch_data_tilde_agency',
  'last_attributed_touch_data_tilde_agency_id',
  'last_attributed_touch_data_tilde_campaign',
  'last_attributed_touch_data_tilde_campaign_id',
  'last_attributed_touch_data_tilde_content_id',
  'last_attributed_touch_data_tilde_creative_id',
  'last_attributed_touch_data_tilde_creative_name',
  'last_attributed_touch_data_tilde_feature',
  'last_attributed_touch_data_tilde_keyword',
  'last_attributed_touch_data_tilde_placement',
  'last_attributed_touch_data_tilde_tags',
  'last_attributed_touch_type',
  'ott',
  'user_data_environment',
  'user_data_geo_country_code',
  'user_data_model',
  'user_data_os',
  'user_data_platform',
  'event_data_local_currency',
];

export const OTT_ANALYTICS_DATASOURCE_COLUMNS = {
  CLICKS: 'eo_click',
  INSTALLS: 'eo_install',
  REINSTALLS: 'eo_reinstall',
  OPENS: 'eo_open',
  IMPRESSIONS: 'eo_impression',
  CUSTOM_EVENT: 'eo_custom_event',
};

export const OTT_ANALYTICS_CALCULATION_COLUMNS = {
  IMPRESSION_CONVERSION_RATE: 'impression_conversion_rate',
};

export const OTT_ANALYTICS_COLUMNS = {
  ...OTT_ANALYTICS_DATASOURCE_COLUMNS,

  REVENUE: 'revenue',
  REVENUE_IN_LOCAL_CURRENCY: 'revenue_in_local_currency',

  COMMERCE_PURCHASES: 'PURCHASE',
  COMMERCE_ADDS_TO_CART: 'ADD_TO_CART',
  COMMERCE_ADDS_TO_WISHLIST: 'ADD_TO_WISHLIST',
  COMMERCE_CART_VIEWS: 'VIEW_CART',
  COMMERCE_PURCHASE_INITS: 'INITIATE_PURCHASE',
  COMMERCE_PAYMENT_INFO_ADDS: 'ADD_PAYMENT_INFO',
  COMMERCE_CREDITS_SPENT: 'SPEND_CREDITS',
  COMMERCE_RESERVES: 'RESERVE',
  COMMERCE_AD_CLICKS: 'CLICK_AD',
  COMMERCE_AD_VIEWS: 'VIEW_AD',

  CONTENT_SEARCH: 'SEARCH',
  CONTENT_ITEM_VIEWS: 'VIEW_ITEM',
  CONTENT_ITEMS_VIEWS: 'VIEW_ITEMS',
  CONTENT_RATES: 'RATE',
  CONTENT_SHARES: 'SHARE',
  CONTENT_STREAM_INITS: 'INITIATE_STREAM',
  CONTENT_STREAM_COMPLETIONS: 'COMPLETE_STREAM',

  USER_LIFECYCLE_REGISTER_COMPLETIONS: 'COMPLETE_REGISTRATION',
  USER_LIFECYCLE_TUTORIAL_COMPLETIONS: 'COMPLETE_TUTORIAL',
  USER_LIFECYCLE_LEVEL_ACHIEVES: 'ACHIEVE_LEVEL',
  USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS: 'UNLOCK_ACHIEVEMENT',
  USER_LIFECYCLE_INVITES: 'INVITE',
  USER_LIFECYCLE_LOGINS: 'LOGIN',
  USER_LIFECYCLE_SUBSCRIPTIONS: 'SUBSCRIBE',
  USER_LIFECYCLE_TRIAL_STARTS: 'START_TRIAL',
  USER_LIFECYCLE_OPT_INS: 'OPT_IN',
  USER_LIFECYCLE_OPT_OUTS: 'OPT_OUT',
};

export const OTT_ANALYTICS_DEFAULT_ACTIVE_COLUMN = OTT_ANALYTICS_COLUMNS.IMPRESSIONS;

export const OTT_ANALYTICS_DEFAULT_SELECTED_COLUMNS = [
  ...new Set([
    OTT_ANALYTICS_DEFAULT_ACTIVE_COLUMN,
    OTT_ANALYTICS_COLUMNS.IMPRESSIONS,
    OTT_ANALYTICS_COLUMNS.INSTALLS,
    OTT_ANALYTICS_COLUMNS.OPENS,
    OTT_ANALYTICS_COLUMNS.REVENUE,
  ]),
];

export const OTT_ANALYTICS_EVENT_LABELS = {
  [OTT_ANALYTICS_CALCULATION_COLUMNS.IMPRESSION_CONVERSION_RATE]: 'Impression Conversion Rate',
};

export const OTT_RELATED_PARTNERS = ['a_samsung_tv_ads', 'a_roku', 'a_dataxu', 'a_vibe', 'a_the_trade_desk'];

export const OTT_WIDGETS_ROW_SIZE = 2;

export const OTT_WIDGETS_LIST = [
  {
    label: 'By Platform',
    dimensionName: 'Platform',
    dimension: 'user_data_platform',
  },
  {
    label: 'By Ad Partner',
    dimensionName: 'Ad Partner',
    dimension: 'last_attributed_touch_data_tilde_advertising_partner_name',
  },
  {
    label: 'By Campaign',
    dimensionName: 'Campaign',
    dimension: 'last_attributed_touch_data_tilde_campaign',
  },
];

export const OTT_WIDGETS_DATASOURCES = [
  {
    label: 'Impressions',
    key: 'impression',
  },
  {
    label: 'Clicks',
    key: 'click',
  },
  {
    label: 'Revenue',
    key: 'revenue',
  },
] as AnalyticsWidgetProps['dataSources'];

export const OTT_WIDGETS_HIGHCHARTS_CONFIG = {
  chart: {
    type: 'variablepie',
    spacing: 0,
    height: 280,
    width: 620,
  },
  credits: {
    enabled: false,
  },
  exporting: {
    enabled: false,
  },
  legend: {
    layout: 'vertical',
    align: 'right',
    verticalAlign: 'middle',
    itemMarginTop: 10,
    itemMarginBottom: 10,
    itemStyle: {
      fontWeight: 'normal',
      fontSize: theme.typography.body2.fontSize,
    },
    symbolWidth: 8,
    symbolHeight: 8,
    useHTML: true,
    labelFormatter: function (this: any) {
      return `
        <div style="min-width: 250px; display: inline-flex; justify-content: space-between; margin-left: 4px; margin-top: 1px;">
          <span style="float: left; white-space: pre-line;">${this.name || 'Unpopulated'}</span>
          <span style="float: right; white-space: pre-line;">${this.y}%</span>
        </div>
      `;
    },
    title: {
      text: `
        <div style="min-width: 250px; display: inline-flex; margin-left: 18px;">
          <span style="float: left; white-space: pre-line;">CHANNEL</span>
          <span style="float: right; white-space: pre-line;">SHARE %</span>
        </div>
      `,
    },
  },
  plotOptions: {
    variablepie: {
      dataLabels: {
        enabled: false,
      },
      showInLegend: true,
      center: [140, '50%'],
      states: {
        inactive: {
          opacity: 1,
        },
        hover: {
          brightness: 0,
          halo: {
            opacity: 1,
          },
        },
      },
    },
  },
  title: {
    text: '',
  },
  tooltip: {
    headerFormat: '',
    pointFormat: `
      <span style="color: #718294" id="ott-tooltip-name">{point.name}</span>
      <br/><b>Share %:</b><span id="ott-tooltip-value"> {point.y}</span><br/>
    `,
  },
  colors: ['#D18CD8', '#A04595', '#FFEDAC', '#7E8EDA', '#2E8F8B', '#3B5297'],
};
